import { render } from "./SiteMenus.vue?vue&type=template&id=1008baa4&scoped=true"
import script from "./SiteMenus.vue?vue&type=script&lang=js"
export * from "./SiteMenus.vue?vue&type=script&lang=js"

import "./SiteMenus.vue?vue&type=style&index=0&id=1008baa4&lang=scss&scoped=true"

import exportComponent from "/home/scotty/git/beamy/monolith/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1008baa4"]])

export default __exports__